<template>
    <div class="d-inline-block">
        <span v-for="(item,index) in dataList" class="k-checkbox--button" :key="index">
            <input v-model="checked" type="checkbox" :name="name"  :value="item.value" class="k-checkbox--button" :id="name+index">
            <label :for="name+index">{{item.label}}</label>
        </span>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "k-btn-checkbox",
        props : ["name","value","dataList"],
        model : {
            prop : 'value',
            event : 'change'
        },
        data(){
          return {
              checked: [...this.value]
          }
        },
        methods : {
        },
        watch : {
            checked(nv){
                this.$emit('change', nv)
            }
        }

    }
</script>

<style scoped>

</style>